import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ActivityEntityName, DomainType, DomainUtility, isPortal, MetadataEntityData } from '@jms/model';
import { UtilService } from '@jms/utils/util.services';
import { Observable, catchError, of, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MetadataService {

    protected http = inject(HttpClient);
    protected _cache = new Map<ActivityEntityName, MetadataEntityData>();

    public getMetadata(entity: ActivityEntityName): Observable<MetadataEntityData> {

        if (this._cache.has(entity)) {
            return of(this._cache.get(entity));
        }

        return this.http
            .get<MetadataEntityData>(`${this.baseUrl}/${entity}`)
            .pipe(
                tap(x => {
                    this._cache.set(entity, x);
                }),
                catchError(err => {
                    return of(null);
                })
            );
    }

    private get baseUrl(): string {

        const domain = UtilService.getLocation().hostName;
        const domainType = DomainUtility.getDomainType(domain);

        switch (domainType) {
            case DomainType.ClientPortal:
            case DomainType.ContractorPortal:
                return `https://__tenant__/api/metadata`

            default:
                return `/api/metadata`

        }
    }
}